import { render, staticRenderFns } from "./VisualizarFuncaoDialog.vue?vue&type=template&id=32984902"
import script from "./VisualizarFuncaoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarFuncaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports